import { ISecurityGroup } from './services';

export const SECURITY_GROUPS_SERVICE_ID = 'security_groups_service_id';

export interface ISecurityGroupsService {
    getAllCloudSecurityGroups(useCache?: boolean): Promise<ISecurityGroup[]>;
    getAllSecurityGroups(useCache?: boolean): Promise<ISecurityGroup[]>;
    getCloudSecurityGroups(cloudAccount: string, region: string, useCache?: boolean): Promise<ISecurityGroup[]>;
}
